import React from 'react';
import { CheckCircle2, Star, FileText, Zap, BookOpen, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-59">
      {/* Above-the-fold block: fits in one iPhone viewport */}
      <div className="min-h-[100svh] flex flex-col items-center justify-between text-center max-w-5xl mx-auto pt-8 pb-6 md:pt-16 md:pb-12 md:min-h-0" data-id="element-60">
        <div className="text-coral-500 font-bold text-xs sm:text-sm uppercase tracking-[0.2em] mb-4" data-id="element-61">
          PROFE LISTO · FUNCIONAL 360
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-stone-900 leading-tight px-2 mb-6" data-id="element-62">
          Todo tu año de funcional resuelto de una vez.
        </h1>

        <div className="relative mx-auto w-full max-w-[280px] sm:max-w-md md:max-w-3xl flex-shrink min-h-0 flex items-center justify-center mb-6" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/nTnnY5o5Teogn2a5VKMFdJ/352.png" alt="Megapack Funcional 360 Elite Bundle" className="relative w-full max-h-[40vh] md:max-h-none h-auto object-contain drop-shadow-xl" loading="eager" decoding="async"
        // @ts-ignore — fetchpriority is a valid HTML attr, types lag
        fetchpriority="high" width="800" height="800" data-id="element-64" />
        </div>

        <div className="w-full max-w-3xl mx-auto flex flex-col items-center gap-6" data-id="element-65">
          <h2 className="text-base sm:text-lg md:text-xl text-stone-600 font-medium max-w-2xl" data-id="element-66">
            Megapack FUNCIONAL 360 — El sistema completo de planificación y
            clases listas para el profesor de entrenamiento funcional argentino
          </h2>

          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm font-medium text-stone-700" data-id="element-67">
            <div className="bg-white px-4 py-2 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-68">
              <FileText className="w-4 h-4 mr-2 text-stone-400" data-id="element-69" /> PDF
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-70">|</span>
            <div className="bg-white px-4 py-2 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-71">
              <Zap className="w-4 h-4 mr-2 text-coral-500" data-id="element-72" /> Acceso Inmediato
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-73">|</span>
            <div className="bg-white px-4 py-2 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-74">
              <BookOpen className="w-4 h-4 mr-2 text-emerald-600" data-id="element-75" /> 12 Tomos +
              6 Bonus + 2 Elite
            </div>
          </div>

          <a href="#pricing" className="inline-block bg-coral-500 hover:bg-coral-600 text-white font-bold text-base sm:text-xl py-4 px-8 rounded-2xl transform transition hover:scale-105 shadow-lg shadow-coral-500/20 w-full sm:w-auto text-center" data-id="element-76">
            💪 QUIERO MI FUNCIONAL 360 AHORA
          </a>

          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm text-stone-600" data-id="element-77">
            <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-78">
              <Shield className="w-4 h-4 mr-2 text-stone-400" data-id="element-79" /> Garantía 7 días
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-80">|</span>
            <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-81">
              <Lock className="w-4 h-4 mr-2 text-stone-400" data-id="element-82" /> Pago seguro
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-83">|</span>
            <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-84">
              <CreditCard className="w-4 h-4 mr-2 text-stone-400" data-id="element-85" /> Tarjetas y
              transferencia
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function SocialProof() {
  return <div className="bg-stone-50 border-y border-stone-200 py-8 mt-8 md:mt-0" data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center items-center gap-8 md:gap-16 text-center" data-id="element-87">
        <div data-id="element-88">
          <p className="text-2xl font-bold text-stone-900" data-id="element-89">+500</p>
          <p className="text-sm text-stone-500" data-id="element-90">profes confían</p>
        </div>
        <div data-id="element-91">
          <p className="text-2xl font-bold text-stone-900" data-id="element-92">12+6</p>
          <p className="text-sm text-stone-500" data-id="element-93">Tomos + Bonus</p>
        </div>
        <div data-id="element-94">
          <div className="flex justify-center text-coral-500 mb-1" data-id="element-95">
            <Star className="w-5 h-5 fill-current" data-id="element-96" />
            <Star className="w-5 h-5 fill-current" data-id="element-97" />
            <Star className="w-5 h-5 fill-current" data-id="element-98" />
            <Star className="w-5 h-5 fill-current" data-id="element-99" />
            <Star className="w-5 h-5 fill-current" data-id="element-100" />
          </div>
          <p className="text-sm text-stone-500" data-id="element-101">4.9/5 calificación ⭐</p>
        </div>
        <div data-id="element-102">
          <p className="text-2xl font-bold text-stone-900" data-id="element-103">🇦🇷</p>
          <p className="text-sm text-stone-500" data-id="element-104">Argentina</p>
        </div>
      </div>
    </div>;
}
export function TestimonialsHero() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-105">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-106">
        <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm relative" data-id="element-107">
          <div className="text-coral-500 mb-4 flex" data-id="element-108">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-109" />)}
          </div>
          <p className="text-stone-700 italic mb-6" data-id="element-110">
            "Organicé todo el mes en una tarde. Nunca más llego al patio sin
            saber qué dar ni cómo progresarlo."
          </p>
          <div className="flex items-center gap-3" data-id="element-111">
            <div className="w-10 h-10 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold" data-id="element-112">
              JM
            </div>
            <div data-id="element-113">
              <p className="text-stone-900 font-semibold text-sm" data-id="element-114">
                — Javier M., Buenos Aires
              </p>
              <p className="text-stone-500 text-xs" data-id="element-115">
                Profesor de Funcional en Box Propio
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm relative" data-id="element-116">
          <div className="text-coral-500 mb-4 flex" data-id="element-117">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-118" />)}
          </div>
          <p className="text-stone-700 italic mb-6" data-id="element-119">
            "Mis alumnos de nivel inicial mejoraron su técnica de sentadilla
            desde la primera semana con el Tomo 2."
          </p>
          <div className="flex items-center gap-3" data-id="element-120">
            <div className="w-10 h-10 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold" data-id="element-121">
              LG
            </div>
            <div data-id="element-122">
              <p className="text-stone-900 font-semibold text-sm" data-id="element-123">
                — Laura G., Córdoba
              </p>
              <p className="text-stone-500 text-xs" data-id="element-124">
                Profesora de Funcional en Gimnasio
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm relative" data-id="element-125">
          <div className="text-coral-500 mb-4 flex" data-id="element-126">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-127" />)}
          </div>
          <p className="text-stone-700 italic mb-6" data-id="element-128">
            "Antes tardaba 1 hora armando una clase. Ahora son 5 minutos y la
            progresión está resuelta."
          </p>
          <div className="flex items-center gap-3" data-id="element-129">
            <div className="w-10 h-10 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold" data-id="element-130">
              PR
            </div>
            <div data-id="element-131">
              <p className="text-stone-900 font-semibold text-sm" data-id="element-132">
                — Pablo R., Rosario
              </p>
              <p className="text-stone-500 text-xs" data-id="element-133">
                Profesor de Funcional Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}